/**
 * Contains a collection of functions relating to setting and resetting of passwords.
 */

import ssFetch from './ssFetch';

/**
 * Updates a user's password using the provided information.
 * @param {Object} loginData Contains the password to set
 * @param {String} loginData.password1 The password
 * @param {String} loginData.providerId The ID of the provider for whom to set a password
 * @param {String} loginData.handle A handle used to identify the particular client
 */
export const setNewUserPassword = function (loginData) {
  if (!!loginData.providerId && !!loginData.handle) {
    const url = `/client/${loginData.providerId}/${loginData.handle}/`;
    return new Promise((resolve, reject) => ssFetch(url, {
      method: 'POST',
      body: JSON.stringify(loginData),
    })
      .then(response => response.json())
      .then(json => {
        if (json.status === 'OK' && json.action) {
          resolve({ data: json });
        } else {
          reject(json);
        }
      })
      .catch(reject));
  }

  return Promise.reject();
};

/**
 * Submits the email to which to send a password reset email. Resolves if the email is sent.
 * @param {String} email The email to which to send a password reset email
 */
export const confirmEmailForPasswordReset = function (email) {
  return ssFetch('/api/v2/auth/password/reset/', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
    .then(response => response.json())
    .then(json => ({ data: json }));
};

/**
 * Verifies that the given token matches that sent in the password reset email.
 * @param {String} token The token received in the request.
 * @param {String} uid The identifier of the token.
 */
export const confirmResetPasswordToken = function (token, uid) {
  return ssFetch('/api/v2/auth/password/reset/validate/', {
    method: 'POST',
    body: JSON.stringify({ token, uid }),
  })
    .then(response => response.json())
    .then(json => ({ data: json }));
};

/**
 * Uses a token received from an email link to reset a user's password.
 * @param {String} token The token received in the request.
 * @param {String} uid The identifier of the token.
 * @param {Object} data The password reset data.
 * @param {String} data.new_password1 The first copy of the password to save.
 * @param {String} data.new_password2 The second copy of the password to save.
 */
export const resetPassword = function (token, uid, data) {
  const reqData = {
    ...data,
    token,
    uid,
  };

  return ssFetch('/api/v2/auth/password/reset/confirm/', {
    method: 'POST',
    body: JSON.stringify(reqData),
  })
    .then(response => response.json())
    .then(json => ({ data: json }));
};
